import { createFileRoute, redirect } from '@tanstack/react-router'

import { isFeatureFlagEnabled } from '@/utils/is-feature-flag-enabled'

export const Route = createFileRoute('/_auth/school-settings/day')({
  beforeLoad: async () => {
    if (!isFeatureFlagEnabled('IS_SCHOOL_DAY_MODULE_ENABLED')) {
      throw redirect({ replace: true, to: '/' })
    }
  }
})
